window.app.controller('reportChartsCtrl', ['$scope', '$http', '$compile', function ($scope, $http, $compile) {
    $scope.credits = [
        {
            id: 654654654,
            date: 1491956210000,
            summ: 210,
            businessType: 'bank',
            type: 'some type',
            currency: 'zl',
            minPayment: 200,
            debt:[
                {
                date: 1491956210000,
                summ: 215,
                },
                
                {
                date: 1492556210000,
                summ: 205,
                },
                {
                date: 1492956210000,
                summ: 155,
                }
            ]
        },
        
    ]
    $scope.requests = [
        {
            id: 654654654,
            date: 1493822210000,
            summ: 190,
            currency: 'zl',
            businessType: 'bank',
        },
        {
            id: 654654654,
            date: 1495822210000,
            summ: 350,
            currency: 'zl',
            businessType: 'bank',
        },
        {
            id: 654654654,
            date: 1490822210000,
            summ:310,
            currency: 'zl',
            businessType: 'bank',
        }
    ];
    $scope.focusedCredit = {
            id: 654654654,
            date: 1491956210000,
            summ: 210,
            businessType: 'bank',
            type: 'some type',
            currency: 'zl',
            minPayment: 200,
            debt:[
                {
                date: 1491956210000,
                summ: 215,
                },
                {
                date: 1492556210000,
                summ: 205,
                },
                {
                date: 1492956210000,
                summ: 155,
                }
            ]
    }
    $scope.showCreditInfoPopup = function(id){
        console.log(id)
    }
    $scope.getChartsData = function(data){
        var test = [];
        for (var i = 0; i < data.length; i++) {
            test.push(data[i]);
            test[i].x = new Date(data[i].date);
            test[i].y = data[i].summ
        }
        return test;
    }
    $scope.charts = {
        credit_and_request: new CanvasJS.Chart("credit_and_request", {
            animationEnabled: true,
            theme: "light2",
            zoomEnabled: true,
            exportEnabled: true,
            toolTip: {
                shared: false,  //disable here. 
                cornerRadius: 10
            },
            title: {
                text: "Credits & Requests"
            },
            axisY: {
                title: "Summ",
                titleFontSize: 24
            },
            axisX: {
                title: "Date",
                titleFontSize: 24
            },
            data: [
                {
                    type: "column",
                    toolTipContent: `{x}<br>credit: {y} {currency}<br>
                                    <button class="ra-btn no-padding" ng-click="showCreditInfoPopup({x})">
                                        Details
                                    </button>`,
                    dataPoints: $scope.getChartsData($scope.credits)
                },
                {
                    type: "column",
                    toolTipContent: `{x}<br>request: {y} {currency}<br>
                                    <button class="ra-btn no-padding" ng-click="showCreditInfoPopup({x})">
                                        Details
                                    </button>`,
                    dataPoints: $scope.getChartsData($scope.requests)
                }
            ]
        }),

        focusedCredit: new CanvasJS.Chart("focusedCredit", {
            animationEnabled: true,
            theme: "light2",
            zoomEnabled: true,
            exportEnabled: true,
            toolTip: {
                shared: false,  //disable here. 
                cornerRadius: 10
            },
            title: {
                text: "Credits"
            },
            axisY: {
                title: "Summ",
                titleFontSize: 24
            },
            axisX: {
                title: "Date",
                titleFontSize: 24
            },
            data: [
                {
                    type: "column",
                    toolTipContent: "{x}<a href = {label} target=\"_blank\"> details</a><br>credit: {y}",
                    dataPoints: $scope.getChartsData($scope.credits)
                }
            ]
        }),

        creditsChart: new CanvasJS.Chart("creditsChart", {
            animationEnabled: true,
            theme: "light2",
            zoomEnabled: true,
            exportEnabled: true,
            toolTip: {
                shared: false,  //disable here. 
                cornerRadius: 10
            },
            title: {
                text: "Credits"
            },
            axisY: {
                title: "Summ",
                titleFontSize: 24
            },
            axisX: {
                title: "Date",
                titleFontSize: 24
            },
            data: [
                {
                    type: "column",
                    toolTipContent: "{x}<a href = {label} target=\"_blank\"> details</a><br>credit: {y}",
                    dataPoints: $scope.getChartsData($scope.credits)
                }
            ]
        }),

        
        chart1: new CanvasJS.Chart("chartContainer1", {
            animationEnabled: true,
            title:{
                text: "Email Categories",
                horizontalAlign: "left",
                fontSize: 15
            },
            data: [{
                type: "doughnut",
                startAngle: 10,
                //innerRadius: 60,
                indexLabelFontSize: 17,
                indexLabel: "{label} - #percent%",
                toolTipContent: "<b>{label}:</b> {y} (#percent%)",
                dataPoints: [
                    { y: 67, label: "Inbox" },
                    { y: 28, label: "Archives" },
                    { y: 10, label: "Labels" },
                    { y: 7, label: "Drafts"},
                    { y: 15, label: "Trash"},
                    { y: 6, label: "Spam"}
                ]
            }]
        }),
        chart2: new CanvasJS.Chart("chartContainer2", {
            theme: "light2", // "light1", "light2", "dark1", "dark2"
            exportEnabled: true,
            animationEnabled: true,
            title: {
                text: "Desktop Browser Market Share in 2016",
                fontSize: 15
            },
            data: [{
                type: "pie",
                startAngle: 25,
                toolTipContent: "<b>{label}</b>: {y}%",
                showInLegend: "true",
                legendText: "{label}",
                indexLabelFontSize: 16,
                indexLabel: "{label} - {y}%",
                dataPoints: [
                    { y: 51.08, label: "Chrome" },
                    { y: 27.34, label: "Internet Explorer" },
                    { y: 10.62, label: "Firefox" },
                    { y: 5.02, label: "Microsoft Edge" },
                    { y: 4.07, label: "Safari" },
                    { y: 1.22, label: "Opera" },
                    { y: 0.44, label: "Others" }
                ]
            }]
        })
    }
    
    $scope.renderCharts = function(){
        window.onload = function(){
            
            $scope.charts.credit_and_request.render();
            $scope.focusedCredit.render();
            $scope.charts.creditsChart.render();
            // $scope.charts.chart1.render();
            // $scope.charts.chart2.render();
            //chartCredits.render();
            $('.canvasjs-chart-credit').hide();
            $('.canvasjs-chart-tooltip').css('pointer-events','auto');
        }
        
    }
}]);


// WEBPACK FOOTER //
// src/js/controllers/reportChartsCtrl.js